import { render } from "./MyBookings.vue?vue&type=template&id=4380b8b0"
import script from "./MyBookings.vue?vue&type=script&lang=js"
export * from "./MyBookings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-2024\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__